// Single source of truth for the crash display curve. MUST stay byte-identical to
// the 155-game-crash engine (engine/multiplier.py) and the Go backend
// (multiplier_service.go) — a mismatch flips the provably-fair modal to "not verified"
// and desyncs the client cash-out clock from server settlement.
// CRASH_REVEAL_DELAY_SECONDS must also stay >= the ~2s bet-grace window (watch-then-bet EV guard).
export const CRASH_REVEAL_DELAY_SECONDS = 3
// 120 -> 76.8 (2026-07-24, pacing): ln(100)/76.8 = 0.05997, matching bustabit's
// published 0.06 to within 0.06%. Climb is 1.5625x faster at every multiplier.
// Not a fairness input — the crash point is seed-derived and the public verifier
// recomputes it with no curve constant.
export const CRASH_RATE = Math.log(100) / 76.8
